import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=ccaa404a&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccaa404a')) {
      api.createRecord('ccaa404a', component.options)
    } else {
      api.reload('ccaa404a', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=ccaa404a&", function () {
      api.rerender('ccaa404a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZzN1PWYsn7MB/JS/pricehelp.vue"
export default component.exports